import { Separator } from '@/components/ui/separator';
import { ChatMessage } from '@/components/chatbot/chat-message';
import { Message } from '@baseai/core';
import { AiLoader } from './ai-loader';
import { CustomStylesI } from '.';
import { useIsDarkMode } from './hooks/use-is-dark-mode';

export interface ChatList {
	messages: Message[];
	showLoadingMessage: boolean;
}

export function ChatList({
	messages,
	showLoadingMessage,
	isLoading,
	customStyles
}: {
	messages: Message[];
	showLoadingMessage: boolean;
	isLoading: boolean;
	customStyles?: CustomStylesI;
}) {
	const isDarkMode = useIsDarkMode();
	if (!messages.length) {
		return null;
	}

	return (
		<div className="lb-relative lb-mx-auto lb-mb-16 lb-mt-4 sm:lb-mt-8">
			{messages.map((message, index) => (
				<div key={index}>
					<ChatMessage
						message={message}
						isLoading={isLoading}
						customStyles={customStyles}
					/>
					{index < messages.length - 1 && (
						<Separator
							className="lb-my-6 md:lb-my-8"
							style={{
								...(customStyles?.chatbot?.backgroundColor && {
									backgroundColor: !isDarkMode
										? customStyles?.chatbot?.backgroundColor
										: customStyles?.chatbot?.foregroundColor
								})
							}}
						/>
					)}
				</div>
			))}
			{showLoadingMessage && (
				<>
					<Separator
						className="lb-my-6 md:lb-my-8"
						style={{
							...(customStyles?.chatbot?.backgroundColor && {
								backgroundColor: !isDarkMode
									? customStyles?.chatbot?.foregroundColor
									: customStyles?.chatbot?.backgroundColor
							})
						}}
					/>
					<AiLoader customStyles={customStyles} />
				</>
			)}
		</div>
	);
}
